import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import StatisticsCards from '@/views/dashboard/_components/statistics-cards/statistics-cards.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'statistics-cards',
  props: {
    todayUploadTraffic: { default: '2.4TB' },
    todayDownloadTraffic: { default: '12TB' },
    effectivePolicies: { default: 21 }
  },
  setup(__props: any) {

const { t } = useI18n()
const props = __props

const statisticsItems = computed(() => [
  { label: t('terminalTrafficStateList.todayUploadTraffic'), value: props.todayUploadTraffic, span: 8 },
  { label: t('terminalTrafficStateList.todayDownloadTraffic'), value: props.todayDownloadTraffic, span: 8 },
  { label: t('terminalTrafficStateList.effectivePolicies'), value: props.effectivePolicies, span: 8 }
])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(StatisticsCards, { items: statisticsItems.value }, null, 8, ["items"]))
}
}

})